import { render, staticRenderFns } from "./FormRole.vue?vue&type=template&id=cbee0be0&"
import script from "./FormRole.vue?vue&type=script&lang=js&"
export * from "./FormRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbee0be0')) {
      api.createRecord('cbee0be0', component.options)
    } else {
      api.reload('cbee0be0', component.options)
    }
    module.hot.accept("./FormRole.vue?vue&type=template&id=cbee0be0&", function () {
      api.rerender('cbee0be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/role/form/FormRole.vue"
export default component.exports